import { LoadedPallet } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { formatPrice } from '@pages/OfferDetail/helpers';
import { LocalizedMessage } from '@services/requests/localizedMessagesService/interfaces';
import { TransportCountByType } from '@services/requests/routeCalculator/cargoConverterService/SelectCargoParametersQuery';
import { ContainersData } from '@services/requests/searchLoaders/containersLoader/ContainersLoaderQuery';
import { TrucksData } from '@services/requests/searchLoaders/trucksLoader/TrucksLoaderQuery';
import { UnitData } from '@services/requests/searchLoaders/unitLoader/UnitLoaderQuery';

/**
 * Получение локализованного названия
 * @param defaultName
 * @param localizations
 */
export const getGeneratedLocalizedName = (
  defaultName: string,
  localizations: LocalizedMessage[],
  language: string
): string => {
  const localization = localizations.find((l) => l.lang_id === language);
  if (!localization || localization.message.length === 0) {
    return defaultName;
  }

  return localization.message;
};

/**
 * Получение массива локализованных параметров паллет
 * @param pallets
 * @param units
 * @param lang
 * @param kgTitle
 */
export const getPalletDescriptions = (
  pallets: LoadedPallet[],
  units: UnitData[],
  lang: string,
  kgTitle: string
): string[] => {
  return pallets
    .map((pallet) => {
      const foundUnit = units.find((p) => p.id === pallet.type);

      if (!foundUnit) {
        return null;
      }

      return `${getGeneratedLocalizedName(
        foundUnit.unit_symbol,
        foundUnit.localized_unit_symbols_data,
        lang
      )} (${formatPrice(pallet.weight, 0)} ${kgTitle}) × ${pallet.quantity}`;
    })
    .filter(Boolean);
};

/**
 * Вычисление короткого описания груза для контейнера
 * @param containers
 * @param cargoContainer
 */
export const getShortCargoForContainer = (
  containers: ContainersData[],
  cargoContainer: TransportCountByType,
  langCode?: string
): string => {
  const container = containers.find((c) => c.id === `${cargoContainer.transportTypeId}`);
  const { default_name = '?', localized_names_data = [] } = container || {};
  const foundLocalization = localized_names_data.find((l) => l.lang_id === langCode);
  const name = foundLocalization?.message?.trim() || default_name;

  return `${name} (${formatPrice(cargoContainer.weight, 0)})`;
};

/**
 * Вычисление короткого описания груза для фуры
 * @param trucks
 * @param cargoTruck
 */
export const getShortCargoForTruck = (
  trucks: TrucksData[],
  cargoTruck: TransportCountByType,
  langCode?: string
): string => {
  const truck = trucks.find((c) => c.id === `${cargoTruck.transportTypeId}`);
  const { default_name = '?', localized_names_data = [] } = truck || {};
  const foundLocalization = localized_names_data.find((l) => l.lang_id === langCode);
  const name = foundLocalization?.message?.trim() || default_name;

  return `${name} (${formatPrice(cargoTruck.weight, 0)})`;
};
